import { EmailDomain, ReadEmailDomainsApiResponse } from 'lib-shared-types-api';

/**
 * Flip the cached tracking state before the server has confirmed it, so the switch moves on the
 * click instead of waiting out the round trip.
 */
export const setEmailDomainTracking = (
  draft: ReadEmailDomainsApiResponse,
  identity: string,
  trackingEnabled: boolean,
): void => {
  const cached = draft.data.email_identities.find(
    (emailDomain) => emailDomain.identity === identity,
  );

  if (cached?.delivery_tracking) {
    Object.assign(cached.delivery_tracking, {
      tracking_enabled: trackingEnabled,
    });
  }
};

/**
 * Merge the tracking state returned by a pixel-tracking write into the cached domain list.
 * Only `delivery_tracking` is touched: replacing the whole identity would tie the cached DNS and
 * verification status to whatever the write path happens to report.
 */
export const patchEmailDomainTracking = (
  draft: ReadEmailDomainsApiResponse,
  updated: EmailDomain,
): void => {
  const cached = draft.data.email_identities.find(
    (emailDomain) => emailDomain.identity === updated.identity,
  );

  if (cached?.delivery_tracking && updated.delivery_tracking) {
    Object.assign(cached.delivery_tracking, updated.delivery_tracking);
  }
};
